$(function () {
    
    /*-------------------------------------------------
    moreボタン
	----------------------------------------------- */
    // liの数を取得
    const listItems = $(".js_feed li").length;
    $(".js_feed").each(function () {
        
        let num = 20,// 最初に表示させるliの数
            
            closeNum = num - 1;// 閉じた時に表示させるliの数
        
        // 最初はもっと見るボタン表示、閉じるボタン非表示
        $(this).find(".js_btn_more").show();
        $(this).find(".js-btn-close").hide();
        
        // 5行目まで表示
        $(this)
            .find("li:not(:lt(" + num + "))")
            .hide();
      
        if (listItems <= num) {
            $(".js_btn_more").hide();
        }
        
        $(".js_btn_more").click(function () {
            num += 20;// numに+5ずつしていく = 5行ずつ追加する
            $(this)
                .parent()
                .find("li:lt(" + num + ")")
                .slideDown();
            // liの数よりnumが多い時
            if (listItems <= num) {
                $(".js_btn_more").hide();
                $(".js-btn-close").show();
                // 閉じるボタンがクリックされた時
                $(".js-btn-close").click(function () {
                    $(this)
                        .parent()
                        .find("li:gt(" + closeNum + ")")
                    // 6行目以降は非表示
                        .slideUp();
                    $(this).hide();
                    $(".js_btn_more").show();
                });
            }
        });
    });
    
});